import { render, staticRenderFns } from "./baseTableData.vue?vue&type=template&id=44c8b05a&scoped=true"
import script from "./baseTableData.vue?vue&type=script&lang=js"
export * from "./baseTableData.vue?vue&type=script&lang=js"
import style0 from "./baseTableData.vue?vue&type=style&index=0&id=44c8b05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8b05a",
  null
  
)

export default component.exports